import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton, Loader } from 'core/components';

// 2. Updated Template
function ScheduledJobLogDetailsTemplate({ scheduledJobLogDetailsViewStore: { data, copyToClipboard }, t }) {
	if (!data || !data.job) return <Loader />;

	const { job } = data;

	const hasErrors = job.errors && job.errors.length > 0;
	const hasWarnings = job.warnings && job.warnings.length > 0;
	const isSuccess = job.errors.length === 0 && job.warnings.length === 0;

	return (
		<section>
			{/* Header */}
			<div className="ReactModal__header">
				<h2 className="spc--bottom--sml">
					{isSuccess ? (
						<i className="type--color--success fa fa-check-circle spc--right--sml" />
					) : (
						<i className="type--color--error fa fa-times-circle spc--right--sml" />
					)}
					{job.jobTitle}
				</h2>
				<div className="spc--bottom--sml">
					<div className="scheduled-job-log-details-modal scheduled-job-log-details-modal__job-identifier-title">
						Job identifier:
					</div>
					<div
						className="scheduled-job-log-details-modal scheduled-job-log-details-modal__job-identifier"
						onClick={() => copyToClipboard(job.jobIdentifier)}
					>
						{job.jobIdentifier}
					</div>
				</div>
			</div>

			<div className="ReactModal__body">
				{/* Error Section */}
				{hasErrors && (
					<div>
						<h3>Errors</h3>
						<LogSection items={job.errors} type="error" />
					</div>
				)}

				{/* Warning Section */}
				{hasWarnings && (
					<div>
						<h3>Warnings</h3>
						<LogSection items={job.warnings} type="warning" />
					</div>
				)}
			</div>

			<div className="ReactModal__footer"></div>
		</section>
	);
}

function LogSection({ items, type }) {
	return (
		<div
			className="scheduled-job-log-details-modal scheduled-job-log-details-modal__list"
			style={{ padding: '1rem 0' }}
		>
			<div className="scheduled-job-log-details-modal__entry">
				<ul className="scheduled-job-log-details-modal__errors scheduled-job-log-details-modal__list_no_bulletpoints">
					{items.map(function(entry, idx) {
						return (
							<li
								key={idx}
								className={
									type === 'error'
										? 'scheduled-job-log-details-modal__error scheduled-job-log-details-modal__list_element'
										: 'scheduled-job-log-details-modal__warning scheduled-job-log-details-modal__list_element'
								}
							>
								{type === 'error' ? (
									<i className="type--color--error fa fa-times-circle spc--right--nano" />
								) : (
									<i className="type--color--warning-light fa fa-exclamation-circle spc--right--nano" />
								)}

								{entry}
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
}

export default defaultTemplate(ScheduledJobLogDetailsTemplate);
